require('./payrollLoanRequestLaboralStatus.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @core
const { formatText, FormattedText } = require('core/i18n').i18n;
// @constants
const {
    PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE,
    PAYROLL_LOAN_JOB_TEMPORAL_EMPLOYEE,
    PAYROLL_LOAN_JOB_STATE_EMPLOYEE,
    PAYROLL_LOAN_JOB_INTERNAL_STATE_EMPLOYEE,
    PAYROLL_LOAN_JOB_PENSIONER,
    PAYROLL_LOAN_JOB_AUTONOMOUS,
    PAYROLL_LOAN_JOB_OTHER
} = require('../../../../../loansConstants/index').payrollLoanJobs;

class payrollLoanLaboralStatus extends React.Component {

    buildJobs() {
        const jobsList = [
            {
                id: PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE,
                transKey: 'payrollLoanRequestStepOne-employedFixed'
            },
            {
                id: PAYROLL_LOAN_JOB_TEMPORAL_EMPLOYEE,
                transKey: 'payrollLoanRequestStepOne-employedTemp'
            },
            {
                id: PAYROLL_LOAN_JOB_STATE_EMPLOYEE,
                transKey: 'payrollLoanRequestStepOne-official'
            },
            {
                id: PAYROLL_LOAN_JOB_INTERNAL_STATE_EMPLOYEE,
                transKey: 'payrollLoanRequestStepOne-interimOfficial'
            },
            {
                id: PAYROLL_LOAN_JOB_PENSIONER,
                transKey: 'payrollLoanRequestStepOne-pensioner'
            },
            {
                id: PAYROLL_LOAN_JOB_AUTONOMOUS,
                transKey: 'payrollLoanRequestStepOne-autonomous'
            },
            {
                id: PAYROLL_LOAN_JOB_OTHER,
                transKey: 'payrollLoanRequestStepOne-others'
            }
        ];

        return jobsList.map((job, index) => {
            const label = formatText(job.transKey);

            return (
                <RadioButton
                    key={'payrollLoanRequestForm-' + index}
                    label={label}
                    value={job.id}
                    className="block-step__radio"
                />
            );
        });
    }

    buildOldBehaviourLaboralStatus() {
        const {
            immContractLoan,
            formHandlers,
        } = this.props;

        const job = immContractLoan.get('job');
        const errorJob = immContractLoan.get('validate') && (job === '');
        const errorMessageJob = formatText('payrollLoanRequestStepOne-payrollLoanRequestStepOne_jobError');

        const jobsList = this.buildJobs();

        return (
            <React.Fragment>
                <h4 className="payroll-loan-request-step-one__input-fields__job-title">
                    <FormattedText value="payrollLoanRequestStepOne-jobTitle" />
                </h4>
                <RadioButtonGroup
                    name="job"
                    idPrefix="jobRadio"
                    onChange={formHandlers.handleJobRadioChange}
                    className="payroll-loan-request-step-one__input-fields__radio-group"
                    selectedValue={job}
                    errorMessage={errorMessageJob}
                    errorState={errorJob}
                >
                    {jobsList}
                </RadioButtonGroup>
            </React.Fragment>
        );
    }

    buildError(value) {
        return (
            <FormattedText
                className="payroll-loan-request-step-one__error"
                value={value}
            />
        );
    }

    buildGenericSelect(params) {
        const {
            immContractLoan,
        } = this.props;

        const label = formatText(params.label);
        const list = immContractLoan.get(params.typeList);
        const listJS = list.size ? list.toJS() : list.toArray();
        const error = immContractLoan.get('validate') && !params.value && this.buildError(params.errorMessage);

        return (
            <div className="row payroll-loan-request-step-one__input-fields__select">
                <div className="col-xs-6">
                    <OKSelect
                        label={label}
                        name={params.name}
                        options={listJS}
                        searchable={false}
                        onChange={params.handleOnChangeEvent}
                        value={params.value}
                        errorState={!!error}
                    />
                </div>
                <div className="col-xs-12">
                    {error}
                </div>
            </div>
        );
    }

    buildJobTypeField() {
        const {
            formHandlers,
            immContractLoan,
        } = this.props;

        const params = {
            errorMessage: "payrollLoanRequestStepOne-payrollLoanRequestStepOne_laboralStatusJobTypeError",
            handleOnChangeEvent: formHandlers.handleJobTypeChange,
            label: "payrollLoanRequestStepOne-payrollLoanRequestStepOne_laboralStatusJobType",
            name: "newJobType-select",
            value: immContractLoan.get('newJobType'),
            typeList: "newJobTypesList",
        };

        return this.buildGenericSelect(params);
    }

    buildEmploymentLevelField() {
        const {
            formHandlers,
            immContractLoan,
        } = this.props;

        const params = {
            errorMessage: "payrollLoanRequestStepOne-payrollLoanRequestStepOne_laboralStatusEmploymentLevelError",
            handleOnChangeEvent: formHandlers.handleEmploymentLevelChange,
            label: "payrollLoanRequestStepOne-payrollLoanRequestStepOne_laboralStatusEmploymentLevel",
            name: "newJobType-select",
            value: immContractLoan.get('employmentLevel'),
            typeList: "employmentLevelList",
        };

        return this.buildGenericSelect(params);
    }

    buildContractTypeField() {
        const {
            formHandlers,
            immContractLoan,
        } = this.props;

        const params = {
            errorMessage: "payrollLoanRequestStepOne-payrollLoanRequestStepOne_laboralStatusContractTypeError",
            handleOnChangeEvent: formHandlers.handleContractTypeChange,
            label: "payrollLoanRequestStepOne-payrollLoanRequestStepOne_laboralStatusContractType",
            name: "contractType-select",
            value: immContractLoan.get('contractType'),
            typeList: "contractTypeList",
        };

        return this.buildGenericSelect(params);
    }

    buildNewBehaviourLaboralStatus() {
        const {
            immContractLoan,
        } = this.props;

        const newJobType = this.buildJobTypeField();
        const employmentLevelList = immContractLoan.get("employmentLevelList")

        const employmentLevel = immContractLoan.get('newJobType') && employmentLevelList.size > 0 &&
            this.buildEmploymentLevelField();
        const contractType = immContractLoan.get('employmentLevel') && immContractLoan.get('contractTypeList').size > 0 &&
            this.buildContractTypeField();

        return (
            <React.Fragment>
                <div className="col-xs-12 payroll-loan-request-laboral-status__title">
                    <FormattedText value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_laboralStatusTitle" />
                </div>
                <div className="payroll-loan-request-laboral-status__subtitle">
                    <FormattedText value="payrollLoanRequestStepOne-payrollLoanRequestStepOne_laboralStatusSubtitle" />
                </div>
                {newJobType}
                {employmentLevel}
                {contractType}
                <div className="payroll-loan-request-laboral-status__separator" />
            </React.Fragment>
        );
    }

    render() {
        const { isDragoFeature } = this.props;
        const laboralStatus = isDragoFeature ? this.buildNewBehaviourLaboralStatus() :
            this.buildOldBehaviourLaboralStatus();

        return (
            <div className="col-xs-12 payroll-loan-request-laboral-status__container">
                {laboralStatus}
            </div>
        );
    }
}

payrollLoanLaboralStatus.propTypes = {
    formHandlers: PropTypes.object.isRequired,
    immContractLoan: PropTypes.object.isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
};

module.exports = payrollLoanLaboralStatus;
